module.exports = __webpack_public_path__ + "img/1_014.f50aec01.jpg";